import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { isEmpty } from 'lodash';
import { getStaticImageUrl } from 'client/utils/image-helpers';
import { FeatureFlag } from 'site-modules/shared/components/feature-flag/feature-flag';

export function SponsoredHeader({ url, image, title, className, titleClassName, impression }) {
  return (
    <div className={classnames('d-flex align-items-baseline flex-column flex-md-row', className)}>
      <h2 className={titleClassName}>{title}</h2>
      {image && url && (
        <FeatureFlag name="ads">
          <div className="d-flex align-items-center" style={{ minHeight: '40px' }}>
            <span className="heading-6 me-1 mx-md-1" aria-hidden>
              Sponsored by
            </span>
            <a href={url} aria-label="sponsor website">
              <img
                className="core-img img-fluid"
                src={getStaticImageUrl(image)}
                alt=""
                decoding="async"
                aria-hidden
                loading="lazy"
              />
            </a>
            {!isEmpty(impression) && (
              <img src={impression} className="border-0" width={1} height={1} alt="" decoding="async" />
            )}
          </div>
        </FeatureFlag>
      )}
    </div>
  );
}

SponsoredHeader.propTypes = {
  url: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  titleClassName: PropTypes.string,
  impression: PropTypes.string,
};

SponsoredHeader.defaultProps = {
  className: null,
  titleClassName: 'text-start heading-3 mb-0 d-md-inline-block',
  impression: '',
};
